import type { PublicGameState, RoomMember } from "@grundbesitz/shared";
import { auctionParticipants, recentBids } from "../../../lib/assets";
import type { ParticipantStatus } from "../../../lib/assets";
import { formatMoney } from "../../../lib/format";
import { PlayerChip } from "../assets/PlayerChip";

const STATUS: Record<ParticipantStatus, { text: string; className: string }> = {
  LEADING: { text: "führt", className: "text-ok font-semibold" },
  BIDDING: { text: "bietet mit", className: "text-ink-2" },
  PASSED: { text: "hat verzichtet", className: "text-ink-2 line-through decoration-1" },
  DEBT: { text: "gesperrt (Schulden)", className: "text-warn font-semibold" },
};

/** Participants with their status, and the latest bids. */
export function BidLog({ game, members, pid }: { game: PublicGameState; members: RoomMember[]; pid: string | null }) {
  const a = game.auction;
  if (!a) return null;
  const participants = auctionParticipants(game);
  const bids = recentBids(a, 6);

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <section aria-labelledby="auction-people">
        <h3 id="auction-people" className="mb-1.5 text-sm font-semibold">
          Teilnehmer
        </h3>
        <ul className="space-y-1">
          {participants.map((p) => (
            <li key={p.playerId} className="flex items-center gap-2 text-sm">
              <PlayerChip game={game} members={members} id={p.playerId} size={18} you={p.playerId === pid} />
              <span className={`ml-auto shrink-0 text-xs ${STATUS[p.status].className}`}>
                {STATUS[p.status].text}
                {p.status === "BIDDING" && p.lastBid !== null ? ` (${formatMoney(p.lastBid)})` : ""}
              </span>
            </li>
          ))}
        </ul>
      </section>

      <section aria-labelledby="auction-bids">
        <h3 id="auction-bids" className="mb-1.5 text-sm font-semibold">
          Gebote
        </h3>
        {bids.length === 0 ? (
          <p className="text-sm text-ink-2">Noch kein Gebot.</p>
        ) : (
          <ol className="space-y-1">
            {bids.map((b, i) => (
              <li key={`${a.bids.length - i}`} className={`flex items-center gap-2 text-sm ${i === 0 ? "font-semibold" : "text-ink-2"}`}>
                <PlayerChip game={game} members={members} id={b.playerId} size={18} you={b.playerId === pid} />
                <span className="ml-auto tabular-nums">{formatMoney(b.amount)}</span>
              </li>
            ))}
          </ol>
        )}
      </section>
    </div>
  );
}
